<!-- src/components/portafolio/TechSolutions.vue -->
<template>
  <div class="tech-solutions">
    <!-- Botón de regreso -->
    <v-btn fab small class="back-button" @click="$router.push('/portafolio')">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <!-- Header con navegación REDISEÑADO -->
    <v-app-bar dark app height="70" class="premium-header">
      <div class="logo-container">
        <div class="logo-icon">
          <v-icon size="24">mdi-code-tags</v-icon>
        </div>
        <span class="logo-text">TECH<span class="logo-highlight">SOLUTIONS</span></span>
      </div>

      <div class="nav-menu d-none d-md-flex">
        <a href="#" class="nav-item" @click.prevent="scrollToTop">Inicio</a>
        <a href="#" class="nav-item" @click.prevent="scrollToSection('servicios')"
          >Servicios</a
        >
        <a href="#" class="nav-item" @click.prevent="scrollToSection('proyectos')"
          >Proyectos</a
        >
        <a href="#" class="nav-item" @click.prevent="scrollToSection('tecnologias')"
          >Tecnologías</a
        >
        <a href="#" class="nav-item" @click.prevent="scrollToSection('blog')">Blog</a>
        <a href="#" class="nav-item" @click.prevent="scrollToSection('contacto')"
          >Contacto</a
        >
      </div>

      <v-spacer></v-spacer>

      <div class="actions-menu d-none d-md-flex">
        <a href="tel:+51917915824" class="phone-link">
          <v-icon size="18">mdi-phone</v-icon>
          +51 928 180 748
        </a>
        <button class="cta-button" @click="scrollToSection('contacto')">
          <v-icon size="18">mdi-rocket</v-icon>
          Cotizar proyecto
        </button>
      </div>

      <button class="mobile-menu-btn hidden-md-and-up" @click="drawer = true">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </v-app-bar>

    <!-- Drawer móvil -->
    <v-navigation-drawer v-model="drawer" app temporary class="mobile-drawer-premium">
      <div class="drawer-header-premium">
        <div class="drawer-logo">
          <v-icon color="#00E5FF">mdi-code-tags</v-icon>
          <span>TechSolutions</span>
        </div>
        <button class="drawer-close" @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
      <div class="drawer-menu">
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToTop();
          "
        >
          <v-icon>mdi-home</v-icon>
          <span>Inicio</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('servicios');
          "
        >
          <v-icon>mdi-code-tags</v-icon>
          <span>Servicios</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('proyectos');
          "
        >
          <v-icon>mdi-rocket</v-icon>
          <span>Proyectos</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('tecnologias');
          "
        >
          <v-icon>mdi-chip</v-icon>
          <span>Tecnologías</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('blog');
          "
        >
          <v-icon>mdi-post</v-icon>
          <span>Blog</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('contacto');
          "
        >
          <v-icon>mdi-phone</v-icon>
          <span>Contacto</span>
        </a>
      </div>
      <div class="drawer-footer">
        <a href="tel:+51917915824" class="drawer-phone-btn">
          <v-icon>mdi-phone</v-icon>
          Llamar ahora
        </a>
        <button class="drawer-cta-btn" @click="scrollToSection('contacto')">
          <v-icon>mdi-rocket</v-icon>
          Cotizar proyecto
        </button>
      </div>
    </v-navigation-drawer>

    <!-- Hero Section -->
    <v-parallax
      src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=1600"
      height="550"
    >
      <v-container fill-height>
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="12" md="8">
            <div class="hero-content">
              <h1 class="display-3 font-weight-bold white--text mb-4">TechSolutions</h1>
              <h2 class="headline white--text mb-6 font-weight-light">
                Innovación tecnológica para impulsar tu negocio
              </h2>
              <div class="hero-buttons">
                <v-btn
                  color="#00E5FF"
                  dark
                  x-large
                  rounded
                  elevation-10
                  class="mx-2"
                  @click="scrollToSection('servicios')"
                >
                  <v-icon left>mdi-rocket</v-icon>
                  Nuestros servicios
                </v-btn>
                <v-btn
                  outlined
                  dark
                  x-large
                  rounded
                  class="mx-2"
                  @click="scrollToSection('contacto')"
                >
                  <v-icon left>mdi-email</v-icon>
                  Contactar ahora
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>

    <!-- Clientes -->
    <v-container class="mt-n8">
      <v-card elevation="10" class="clients-card">
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <h3 class="title font-weight-light mb-4">
                Empresas que confían en nosotros
              </h3>
            </v-col>
            <v-col v-for="(cliente, idx) in clientes" :key="idx" cols="6" sm="4" md="2">
              <v-img :src="cliente.logo" height="50" contain class="client-logo"></v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- Servicios -->
    <v-container id="servicios" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Nuestros servicios</h2>
          <p class="subtitle-1 grey--text">Soluciones tecnológicas a tu medida</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(servicio, idx) in servicios" :key="idx" cols="12" sm="6" md="4">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="service-card"
              :class="{ 'service-card-hover': hover }"
              @click="verServicio(servicio)"
            >
              <div class="service-icon">
                <v-icon size="48" :color="servicio.color">{{ servicio.icono }}</v-icon>
              </div>
              <v-card-title class="justify-center pt-4">{{
                servicio.nombre
              }}</v-card-title>
              <v-card-text class="text-center">
                <p class="body-2 grey--text">{{ servicio.descripcion }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  block
                  :color="servicio.color"
                  outlined
                  rounded
                  @click.stop="verServicio(servicio)"
                >
                  Saber más
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Estadísticas -->
    <v-container class="mt-12">
      <v-card color="#0D47A1" dark class="stats-card">
        <v-container>
          <v-row>
            <v-col
              v-for="(stat, idx) in estadisticas"
              :key="idx"
              cols="6"
              md="3"
              class="text-center"
            >
              <div class="stat-item">
                <v-icon size="40" color="#00E5FF">{{ stat.icono }}</v-icon>
                <h3 class="display-1 font-weight-bold mt-2">{{ stat.valor }}</h3>
                <p class="subtitle-1">{{ stat.label }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- Tecnologías -->
    <v-container id="tecnologias" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Tecnologías que manejamos</h2>
          <p class="subtitle-1 grey--text">Stack tecnológico de vanguardia</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(tech, idx) in tecnologias" :key="idx" cols="6" sm="4" md="2">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 8 : 2"
              class="tech-card text-center pa-3"
              :class="{ 'tech-card-hover': hover }"
            >
              <v-img :src="tech.logo" height="60" contain></v-img>
              <p class="mt-2 mb-0 font-weight-bold caption">{{ tech.nombre }}</p>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Proyectos destacados -->
    <v-container id="proyectos" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Proyectos destacados</h2>
          <p class="subtitle-1 grey--text">Casos de éxito que nos respaldan</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(proyecto, idx) in proyectosDestacados" :key="idx" cols="12" md="4">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="project-card"
              @click="verProyecto(proyecto)"
            >
              <v-img :src="proyecto.imagen" height="200" class="project-image" cover>
                <div class="project-overlay" v-if="hover">
                  <v-btn
                    fab
                    small
                    dark
                    color="#2962FF"
                    @click.stop="verProyecto(proyecto)"
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-img>
              <v-card-title>{{ proyecto.nombre }}</v-card-title>
              <v-card-text>
                <p class="body-2 grey--text">{{ proyecto.descripcion }}</p>
                <div class="d-flex align-center mt-2">
                  <v-chip small :color="proyecto.color" dark>{{
                    proyecto.categoria
                  }}</v-chip>
                  <span class="ml-2 caption">{{ proyecto.tecnologias }}</span>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Testimonios -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Lo que dicen nuestros clientes</h2>
          <p class="subtitle-1 grey--text">
            Clientes satisfechos con nuestras soluciones
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(testimonio, idx) in testimonios" :key="idx" cols="12" md="4">
          <v-card class="testimonial-card pa-4" elevation="3">
            <v-card-text>
              <v-icon color="#00E5FF" size="32" class="mb-2"
                >mdi-format-quote-open</v-icon
              >
              <p class="body-1 font-italic">"{{ testimonio.texto }}"</p>
              <div class="d-flex align-center mt-4">
                <v-avatar size="50">
                  <v-img :src="testimonio.avatar"></v-img>
                </v-avatar>
                <div class="ml-3">
                  <p class="mb-0 font-weight-bold">{{ testimonio.nombre }}</p>
                  <p class="caption grey--text mb-0">
                    {{ testimonio.cargo }} | {{ testimonio.empresa }}
                  </p>
                  <v-rating
                    :value="testimonio.rating"
                    readonly
                    dense
                    small
                    color="#FFD700"
                  ></v-rating>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Metodología -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Nuestra metodología</h2>
          <p class="subtitle-1 grey--text">Cómo trabajamos para garantizar tu éxito</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(metodo, idx) in metodologia" :key="idx" cols="12" sm="6" md="3">
          <v-card class="method-card text-center pa-4" elevation="2">
            <div class="method-number">{{ metodo.numero }}</div>
            <v-icon size="48" :color="metodo.color">{{ metodo.icono }}</v-icon>
            <h3 class="title mt-3">{{ metodo.titulo }}</h3>
            <p class="body-2 grey--text mt-2">{{ metodo.descripcion }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Blog -->
    <v-container id="blog" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Últimos artículos</h2>
          <p class="subtitle-1 grey--text">Tendencias y novedades del mundo tech</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(articulo, idx) in blogPosts" :key="idx" cols="12" md="4">
          <v-card class="blog-card" elevation="3" @click="verArticulo(articulo)">
            <v-img :src="articulo.imagen" height="180" cover>
              <div class="blog-category">
                <v-chip small dark :color="articulo.color">{{
                  articulo.categoria
                }}</v-chip>
              </div>
            </v-img>
            <v-card-title class="pb-0">{{ articulo.titulo }}</v-card-title>
            <v-card-text>
              <p class="body-2 grey--text">{{ articulo.resumen }}</p>
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="d-flex align-center">
                  <v-icon small class="mr-1">mdi-calendar</v-icon>
                  <span class="caption">{{ articulo.fecha }}</span>
                </div>
                <div class="d-flex align-center">
                  <v-icon small class="mr-1">mdi-clock</v-icon>
                  <span class="caption">{{ articulo.tiempo }} min lectura</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Formulario de contacto -->
    <v-container id="contacto" class="mt-12">
      <v-card color="#F5F5F5" class="pa-8">
        <v-row>
          <v-col cols="12" md="6">
            <h2 class="display-1 font-weight-bold mb-4">¿Tienes un proyecto en mente?</h2>
            <p class="subtitle-1 grey--text">
              Cuéntanos tu idea y te ayudaremos a hacerla realidad
            </p>

            <v-form ref="formContacto" v-model="validContacto" class="mt-6">
              <v-text-field
                v-model="contacto.nombre"
                label="Nombre completo"
                outlined
                :rules="[(v) => !!v || 'Campo requerido']"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
              <v-text-field
                v-model="contacto.email"
                label="Correo electrónico"
                outlined
                type="email"
                :rules="[
                  (v) => !!v || 'Campo requerido',
                  (v) => /.+@.+\..+/.test(v) || 'Email inválido',
                ]"
                prepend-inner-icon="mdi-email"
              ></v-text-field>
              <v-text-field
                v-model="contacto.telefono"
                label="Teléfono / Celular"
                outlined
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
              <v-select
                v-model="contacto.servicio"
                :items="servicios.map((s) => s.nombre)"
                label="Servicio de interés"
                outlined
                prepend-inner-icon="mdi-code-tags"
              ></v-select>
              <v-textarea
                v-model="contacto.mensaje"
                label="Cuéntanos sobre tu proyecto"
                outlined
                rows="4"
                :rules="[(v) => !!v || 'Campo requerido']"
                prepend-inner-icon="mdi-message"
              ></v-textarea>
              <v-btn
                color="#2962FF"
                dark
                x-large
                block
                rounded
                :disabled="!validContacto"
                @click="enviarContacto"
              >
                <v-icon left>mdi-rocket</v-icon>
                Enviar cotización
              </v-btn>
            </v-form>
          </v-col>

          <v-col cols="12" md="6">
            <v-img
              src="https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=600"
              height="100%"
              class="rounded-lg"
              cover
            ></v-img>

            <div class="mt-4">
              <h3 class="title">Información de contacto</h3>
              <div class="mt-3">
                <p>
                  <v-icon small class="mr-2" color="#2962FF">mdi-map-marker</v-icon> Av.
                  Tecnología 123, San Isidro, Lima - Perú
                </p>
                <p>
                  <v-icon small class="mr-2" color="#2962FF">mdi-phone</v-icon> +51 928
                  180 748
                </p>
                <p>
                  <v-icon small class="mr-2" color="#2962FF">mdi-whatsapp</v-icon> +51 987
                  654 321
                </p>
                <p>
                  <v-icon small class="mr-2" color="#2962FF">mdi-email</v-icon>
                  hola@techsolutions.com
                </p>
              </div>

              <v-divider class="my-4"></v-divider>

              <h3 class="title">Horario de atención</h3>
              <div class="mt-3">
                <p><strong>Lunes a Viernes:</strong> 9:00 am - 7:00 pm</p>
                <p><strong>Sábados:</strong> 10:00 am - 2:00 pm</p>
                <p><strong>Soporte 24/7:</strong> Emergencias técnicas</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- Newsletter -->
    <v-container class="mt-12">
      <v-card color="#0D47A1" dark class="pa-8 text-center">
        <v-card-title class="display-1 justify-center font-weight-light"
          >¡Suscríbete a nuestro newsletter!</v-card-title
        >
        <v-card-text class="subtitle-1"
          >Recibe las últimas novedades del mundo tech y ofertas exclusivas</v-card-text
        >
        <v-form class="mt-4">
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-text-field
                v-model="newsletterEmail"
                label="Tu correo electrónico"
                outlined
                dark
                solo
                placeholder="ejemplo@correo.com"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="#00E5FF"
                dark
                x-large
                rounded
                block
                @click="suscribirNewsletter"
                >Suscribirme</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <p class="caption mt-4">
          No enviaremos spam. Puedes cancelar tu suscripción en cualquier momento.
        </p>
      </v-card>
    </v-container>

    <!-- Footer -->
    <v-footer color="#0D47A1" dark class="mt-12">
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-icon large class="mb-2" color="#00E5FF">mdi-code-tags</v-icon>
            <h3 class="title">TechSolutions</h3>
            <p class="caption mt-2">
              Innovación tecnológica para impulsar tu negocio desde 2018
            </p>
            <div class="mt-3">
              <v-btn icon dark class="mr-2"><v-icon>mdi-facebook</v-icon></v-btn>
              <v-btn icon dark class="mr-2"><v-icon>mdi-linkedin</v-icon></v-btn>
              <v-btn icon dark class="mr-2"><v-icon>mdi-github</v-icon></v-btn>
              <v-btn icon dark><v-icon>mdi-twitter</v-icon></v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Servicios</h3>
            <v-list dense dark>
              <v-list-item v-for="serv in servicios.slice(0, 4)" :key="serv.nombre">
                <v-list-item-content class="caption">{{
                  serv.nombre
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Enlaces</h3>
            <v-list dense dark>
              <v-list-item @click="scrollToTop"
                ><v-list-item-content>Inicio</v-list-item-content></v-list-item
              >
              <v-list-item @click="scrollToSection('servicios')"
                ><v-list-item-content>Servicios</v-list-item-content></v-list-item
              >
              <v-list-item @click="scrollToSection('contacto')"
                ><v-list-item-content>Contacto</v-list-item-content></v-list-item
              >
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Legal</h3>
            <v-list dense dark>
              <v-list-item
                ><v-list-item-content
                  >Términos y condiciones</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >Política de privacidad</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >Libro de reclamaciones</v-list-item-content
                ></v-list-item
              >
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Contacto</h3>
            <p class="caption">
              <v-icon small class="mr-1">mdi-phone</v-icon> +51 928 180 748<br />
              <v-icon small class="mr-1">mdi-email</v-icon> hola@techsolutions.com
            </p>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>
        <div class="text-center caption">
          © 2024 TechSolutions - Todos los derechos reservados. <br />"Transformando ideas
          en soluciones digitales"
        </div>
      </v-container>
    </v-footer>

    <!-- Dialog de confirmación -->
    <v-dialog v-model="dialogConfirmacion" max-width="400">
      <v-card>
        <v-card-title class="headline success--text">
          <v-icon left color="success" large>mdi-check-circle</v-icon>
          ¡Mensaje enviado!
        </v-card-title>
        <v-card-text>
          Gracias {{ contacto.nombre }}. Hemos recibido tu consulta. <br /><br />
          Un asesor te contactará a la brevedad para discutir los detalles de tu proyecto.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#2962FF" text @click="dialogConfirmacion = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "TechSolutions",
  data() {
    return {
      drawer: false,
      validContacto: false,
      dialogConfirmacion: false,
      newsletterEmail: "",
      contacto: {
        nombre: "",
        email: "",
        telefono: "",
        servicio: "",
        mensaje: "",
      },
      clientes: [
        { logo: "https://placehold.co/100x50/2962FF/white?text=Cliente+1" },
        { logo: "https://placehold.co/100x50/2962FF/white?text=Cliente+2" },
        { logo: "https://placehold.co/100x50/2962FF/white?text=Cliente+3" },
        { logo: "https://placehold.co/100x50/2962FF/white?text=Cliente+4" },
        { logo: "https://placehold.co/100x50/2962FF/white?text=Cliente+5" },
        { logo: "https://placehold.co/100x50/2962FF/white?text=Cliente+6" },
      ],
      servicios: [
        {
          nombre: "Desarrollo Web",
          icono: "mdi-web",
          color: "#2962FF",
          descripcion: "Creación de sitios web modernos, rápidos y responsivos",
        },
        {
          nombre: "Apps Móviles",
          icono: "mdi-cellphone",
          color: "#00E5FF",
          descripcion: "Desarrollo de aplicaciones nativas para iOS y Android",
        },
        {
          nombre: "Cloud Computing",
          icono: "mdi-cloud",
          color: "#FF9800",
          descripcion: "Soluciones en la nube, migración y optimización",
        },
        {
          nombre: "Consultoría IT",
          icono: "mdi-consultation",
          color: "#4CAF50",
          descripcion: "Asesoría tecnológica y transformación digital",
        },
        {
          nombre: "Ciberseguridad",
          icono: "mdi-shield-lock",
          color: "#F44336",
          descripcion: "Protección de datos y seguridad informática",
        },
        {
          nombre: "Inteligencia Artificial",
          icono: "mdi-brain",
          color: "#9C27B0",
          descripcion: "Soluciones con IA y machine learning",
        },
      ],
      estadisticas: [
        { icono: "mdi-rocket", valor: "150+", label: "Proyectos entregados" },
        { icono: "mdi-account-group", valor: "50+", label: "Clientes satisfechos" },
        { icono: "mdi-code-tags", valor: "30+", label: "Tecnologías" },
        { icono: "mdi-star", valor: "4.9", label: "Calificación promedio" },
      ],
      tecnologias: [
        { nombre: "Vue.js", logo: "https://placehold.co/80x60/42B883/white?text=Vue" },
        { nombre: "React", logo: "https://placehold.co/80x60/61DAFB/white?text=React" },
        {
          nombre: "Angular",
          logo: "https://placehold.co/80x60/DD0031/white?text=Angular",
        },
        { nombre: "Node.js", logo: "https://placehold.co/80x60/339933/white?text=Node" },
        { nombre: "Python", logo: "https://placehold.co/80x60/3776AB/white?text=Python" },
        { nombre: "Java", logo: "https://placehold.co/80x60/007396/white?text=Java" },
        { nombre: "AWS", logo: "https://placehold.co/80x60/FF9900/white?text=AWS" },
        { nombre: "Docker", logo: "https://placehold.co/80x60/2496ED/white?text=Docker" },
        {
          nombre: "Kubernetes",
          logo: "https://placehold.co/80x60/326CE5/white?text=K8s",
        },
        { nombre: "MongoDB", logo: "https://placehold.co/80x60/47A248/white?text=Mongo" },
        {
          nombre: "PostgreSQL",
          logo: "https://placehold.co/80x60/336791/white?text=Postgres",
        },
        {
          nombre: "Firebase",
          logo: "https://placehold.co/80x60/FFCA28/white?text=Firebase",
        },
      ],
      proyectosDestacados: [
        {
          nombre: "E-commerce Corporativo",
          descripcion: "Plataforma de ventas online con gestión de inventario",
          categoria: "Web",
          color: "#2962FF",
          tecnologias: "Vue.js, Node.js, MongoDB",
          imagen:
            "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=600",
        },
        {
          nombre: "App de Delivery",
          descripcion: "Aplicación móvil para pedidos y seguimiento en tiempo real",
          categoria: "Móvil",
          color: "#00E5FF",
          tecnologias: "React Native, Firebase",
          imagen:
            "https://images.pexels.com/photos/1181672/pexels-photo-1181672.jpeg?auto=compress&cs=tinysrgb&w=600",
        },
        {
          nombre: "Sistema Cloud",
          descripcion: "Migración y optimización de infraestructura a la nube",
          categoria: "Cloud",
          color: "#FF9800",
          tecnologias: "AWS, Docker, Kubernetes",
          imagen:
            "https://images.pexels.com/photos/1181673/pexels-photo-1181673.jpeg?auto=compress&cs=tinysrgb&w=600",
        },
      ],
      testimonios: [
        {
          nombre: "Carlos Mendoza",
          texto:
            "TechSolutions transformó completamente nuestra presencia digital. El equipo es muy profesional y cumplió con todos los plazos.",
          rating: 5,
          cargo: "CEO",
          empresa: "Empresa Líder",
          avatar: "https://randomuser.me/api/portraits/men/1.jpg",
        },
        {
          nombre: "Ana Ramírez",
          texto:
            "Excelente trabajo en el desarrollo de nuestra app móvil. Altamente recomendados para proyectos tecnológicos.",
          rating: 5,
          cargo: "Product Manager",
          empresa: "Startup Innovadora",
          avatar: "https://randomuser.me/api/portraits/women/2.jpg",
        },
        {
          nombre: "Javier Torres",
          texto:
            "La consultoría que nos brindaron ayudó a optimizar nuestros procesos en un 40%. Muy satisfecho con el resultado.",
          rating: 5,
          cargo: "CTO",
          empresa: "Corporación Tech",
          avatar: "https://randomuser.me/api/portraits/men/3.jpg",
        },
      ],
      metodologia: [
        {
          numero: "01",
          titulo: "Descubrimiento",
          icono: "mdi-lightbulb",
          color: "#FF9800",
          descripcion: "Analizamos tus necesidades y objetivos del proyecto",
        },
        {
          numero: "02",
          titulo: "Planificación",
          icono: "mdi-chart-line",
          color: "#2962FF",
          descripcion: "Diseñamos una estrategia personalizada para tu negocio",
        },
        {
          numero: "03",
          titulo: "Desarrollo",
          icono: "mdi-code-tags",
          color: "#00E5FF",
          descripcion: "Implementamos la solución con metodologías ágiles",
        },
        {
          numero: "04",
          titulo: "Entrega",
          icono: "mdi-rocket",
          color: "#4CAF50",
          descripcion: "Lanzamos tu proyecto y brindamos soporte continuo",
        },
      ],
      blogPosts: [
        {
          titulo: "Tendencias tecnológicas 2024",
          resumen: "Descubre las tecnologías que dominarán el mercado este año",
          categoria: "Tendencias",
          color: "#FF9800",
          fecha: "15/06/2024",
          tiempo: 5,
          imagen:
            "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=600",
        },
        {
          titulo: "Mejores prácticas en desarrollo web",
          resumen: "Consejos y buenas prácticas para desarrolladores web",
          categoria: "Desarrollo",
          color: "#2962FF",
          fecha: "10/06/2024",
          tiempo: 7,
          imagen:
            "https://images.pexels.com/photos/1181672/pexels-photo-1181672.jpeg?auto=compress&cs=tinysrgb&w=600",
        },
        {
          titulo: "Guía de ciberseguridad para empresas",
          resumen: "Cómo proteger tu negocio de amenazas digitales",
          categoria: "Seguridad",
          color: "#F44336",
          fecha: "05/06/2024",
          tiempo: 6,
          imagen:
            "https://images.pexels.com/photos/1181673/pexels-photo-1181673.jpeg?auto=compress&cs=tinysrgb&w=600",
        },
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    verServicio(servicio) {
      alert(`Más información sobre: ${servicio.nombre}`);
    },
    verProyecto(proyecto) {
      alert(`Ver detalles del proyecto: ${proyecto.nombre}`);
    },
    verArticulo(articulo) {
      alert(`Leyendo: ${articulo.titulo}`);
    },
    enviarContacto() {
      if (this.$refs.formContacto.validate()) {
        this.dialogConfirmacion = true;
        console.log("Contacto enviado:", this.contacto);
        setTimeout(() => {
          this.contacto = {
            nombre: "",
            email: "",
            telefono: "",
            servicio: "",
            mensaje: "",
          };
          this.$refs.formContacto.reset();
        }, 2000);
      }
    },
    suscribirNewsletter() {
      if (this.newsletterEmail && /.+@.+\..+/.test(this.newsletterEmail)) {
        alert("¡Gracias por suscribirte! Recibirás nuestras novedades.");
        this.newsletterEmail = "";
      } else {
        alert("Por favor ingresa un email válido");
      }
    },
  },
};
</script>

<style scoped>
.tech-solutions {
  background: #f8f9fa;
  min-height: 100vh;
}

/* Botón de regreso */
.back-button {
  position: fixed;
  top: 85px;
  left: 24px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  color: #2962ff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.back-button:hover {
  background: #2962ff;
  color: white;
  transform: translateX(-3px);
}

/* Header Premium */
.premium-header {
  background: rgba(13, 71, 161, 0.96) !important;
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(0, 229, 255, 0.3);
  height: 70px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}
.premium-header .v-toolbar__content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 32px;
  height: 70px !important;
  display: flex;
  align-items: center;
}

/* Logo */
.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #2962ff, #00e5ff);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(41, 98, 255, 0.3);
}
.logo-icon .v-icon {
  color: white;
}
.logo-text {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #fff, #ccc);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.logo-highlight {
  color: #00e5ff;
  background: none;
  -webkit-background-clip: unset;
  background-clip: unset;
}

/* Menú central */
.nav-menu {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 12px;
  border-radius: 50px;
  margin: 0 24px;
}
.nav-item {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 0.85rem;
  padding: 8px 16px;
  border-radius: 40px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.nav-item:hover {
  color: #00e5ff;
  background: rgba(0, 229, 255, 0.15);
}

/* Acciones derecha */
.actions-menu {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}
.phone-link {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
  font-size: 0.85rem;
  padding: 8px 16px;
  border-radius: 40px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(0, 229, 255, 0.3);
}
.phone-link:hover {
  color: #00e5ff;
  background: rgba(0, 229, 255, 0.1);
  border-color: #00e5ff;
}
.cta-button {
  background: linear-gradient(135deg, #00e5ff, #2962ff);
  border: none;
  padding: 8px 20px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}
.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 229, 255, 0.4);
}

/* Botón menú móvil */
.mobile-menu-btn {
  background: transparent;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.mobile-menu-btn span {
  width: 22px;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.mobile-menu-btn:hover span {
  background: #00e5ff;
}

/* Drawer móvil */
.mobile-drawer-premium {
  background: #0a1e3f;
  width: 280px;
}
.drawer-header-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.drawer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
}
.drawer-close {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
}
.drawer-close:hover {
  background: rgba(0, 229, 255, 0.3);
}
.drawer-menu {
  padding: 16px;
}
.drawer-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  margin: 4px 0;
  border-radius: 12px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  cursor: pointer;
}
.drawer-item:hover {
  background: rgba(0, 229, 255, 0.15);
  color: #00e5ff;
}
.drawer-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.drawer-phone-btn,
.drawer-cta-btn {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  padding: 10px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}
.drawer-phone-btn:hover {
  background: rgba(0, 229, 255, 0.3);
}
.drawer-cta-btn {
  background: linear-gradient(135deg, #00e5ff, #2962ff);
}
.drawer-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 229, 255, 0.4);
}

/* Resto de estilos */
.hero-content {
  background: rgba(0, 0, 0, 0.4);
  padding: 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}
.hero-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
}
.clients-card {
  margin-top: -40px;
  background: white;
  border-radius: 20px;
  position: relative;
  z-index: 10;
}
.client-logo {
  filter: grayscale(100%);
  opacity: 0.6;
  transition: all 0.3s ease;
}
.client-logo:hover {
  filter: grayscale(0%);
  opacity: 1;
}
.service-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  height: 100%;
  text-align: center;
}
.service-card-hover {
  transform: translateY(-8px);
}
.service-icon {
  margin-top: 20px;
}
.stats-card {
  border-radius: 20px;
  overflow: hidden;
}
.stat-item {
  padding: 20px;
}
.tech-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  height: 100%;
}
.tech-card-hover {
  transform: translateY(-5px);
  background: #e3f2fd;
}
.project-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  height: 100%;
}
.project-card:hover {
  transform: translateY(-8px);
}
.project-image {
  position: relative;
  overflow: hidden;
}
.project-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.testimonial-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 15px;
}
.testimonial-card:hover {
  transform: translateY(-5px);
}
.method-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 15px;
  position: relative;
}
.method-card:hover {
  transform: translateY(-5px);
}
.method-number {
  position: absolute;
  top: -15px;
  left: 20px;
  background: #2962ff;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
}
.blog-card {
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  height: 100%;
}
.blog-card:hover {
  transform: translateY(-5px);
}
.blog-category {
  position: absolute;
  top: 10px;
  right: 10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.service-card,
.tech-card,
.project-card,
.testimonial-card,
.method-card,
.blog-card {
  animation: fadeIn 0.6s ease;
}

@media (max-width: 960px) {
  .premium-header .v-toolbar__content {
    padding: 0 20px;
  }
}
@media (max-width: 600px) {
  .display-3 {
    font-size: 2rem !important;
  }
  .display-1 {
    font-size: 1.8rem !important;
  }
  .hero-content {
    padding: 20px;
  }
  .hero-buttons {
    flex-direction: column;
  }
  .clients-card {
    margin-top: -20px;
  }
  .service-card,
  .tech-card,
  .project-card {
    margin-bottom: 16px;
  }
  .logo-text {
    font-size: 0.9rem;
  }
  .logo-icon {
    width: 30px;
    height: 30px;
  }
  .back-button {
    top: 80px;
    left: 16px;
  }
}

::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #2962ff;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: #0d47a1;
}
</style>
